module.exports = __webpack_public_path__ + "img/agriworks-alternate.e21f95b0.jpg";